document.addEventListener('DOMContentLoaded', function () {
  const filterButtons = document.querySelectorAll('.filter-buttons');
  const allCards = document.querySelectorAll('.test-card-all');

  filterButtons.forEach(button => {
    button.addEventListener('click', function () {
      const filter = this.getAttribute('data-filter');

      // Remove active class from all buttons
      filterButtons.forEach(btn => btn.classList.remove('active'));

      // Add active class to the clicked button
      this.classList.add('active');

      // Show/hide testimonial cards
       allCards.forEach(card => {
        // Determine visibility
        const shouldShow = filter === 'test-card-all' || card.classList.contains(filter);

        if (shouldShow) {
          card.classList.remove('card-hidden');
        } else {
          card.classList.add('card-hidden');
        }
      });
    });
  });
});